const iraConsentTemplate = `
<pwr-ira-consent-component
    group-id="groupId"
    individual-id="individualId"
    go-to-next-location = "goToNextLocation"
></pwr-ira-consent-component>
`;
export default iraConsentTemplate;
